<template>
  <el-drawer
    title="查看奖品"
    :size="600"
    :visible.sync="drawerVisible"
  >
    <SpFinder
      ref="finder"
      row-key="id"
      url="/lottery/gift/extend/list"
      :setting="setting"
      no-selection
      fixed-row-action
      :hooks="{ beforeSearch }"
    />
  </el-drawer>
</template>

<script>
import { createSetting } from '@shopex/finder'
import { deleteLotteryGiftExtend } from '@/api/lotteryGift'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    giftInfo: {
      type: Object,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    setting() {
      return createSetting({
        columns: this.buildColumns()
      })
    }
  },
  watch: {
    drawerVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.finder && this.$refs.finder.refresh()
        })
      }
    }
  },
  methods: {
    beforeSearch(params) {
      return {
        ...params,
        page_size: params.pageSize,
        gift_id: this.giftInfo.id
      }
    },
    getExtendDataMarketingTitle(extendData) {
      if (!extendData) return ''
      if (typeof extendData === 'string') {
        try {
          const parsed = JSON.parse(extendData)
          return parsed && parsed.marketing_title ? parsed.marketing_title : ''
        } catch (error) {
          return ''
        }
      }
      return extendData.marketing_title || ''
    },
    buildColumns() {
      const columns = [
        { name: '奖品名称', key: 'name' },
        { name: '奖品编号', key: 'code' }
      ]
      const giftType = this.giftInfo && this.giftInfo.gift_type
      if (giftType === 'redpacket_cover') {
        columns.push({ name: '兑换code', key: 'redeem_code' })
      }
      if (giftType === 'emoji') {
        columns.push({ name: '领取链接', key: 'url' })
      }
      if (giftType === 'wallpaper') {
        columns.push({ name: '墙纸URL', key: 'url' })
      }
      if (giftType === 'points') {
        columns.push(
          { name: 'CRM积分发放活动', key: 'marketing_code' },
          {
            name: 'CRM积分发放活动名称',
            key: 'extend_data',
            render: (h, { row }) => {
              const title = this.getExtendDataMarketingTitle(row.extend_data)
              return <span>{title}</span>
            }
          }
        )
      }
      columns.push({
        name: '操作',
        key: 'action',
        fixed: 'right',
        render: (h, { row }) => {
          return (
            <el-button type="text" class="btn-gap" onClick={() => this.deleteGiftItem(row)}>
              删除
            </el-button>
          )
        }
      })
      return columns
    },
    deleteGiftItem(item) {
      this.$confirm('确定删除该奖品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteLotteryGiftExtend({ id: item.id }).then(() => {
          this.$refs.finder.refresh()
        })
      })
    }
  }
}
</script>
